module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "socials-wrapper socials-auth"
  }, [_c('ul', {
    staticClass: "social-list"
  }, [_c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link fb",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.socialAuth('/auth/social/facebook');
      }
    }
  }, [_c('fb')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "social-item"
  }, [_c('a', {
    staticClass: "social-link vk",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.socialAuth('/auth/social/vkontakte');
      }
    }
  }, [_c('vk')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44695680","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SocialsAuth.vue
// module id = 500
// module chunks = 1